import { ShopifyProduct } from '../shopify';
import { getContentType } from '@/core/constants';
import { Entry, EntryCollection } from 'contentful';

async function updateVariantImage(entry: Entry<any>) {
  const contentType = getContentType(entry);
  if (contentType === 'product' && entry.fields.shopifyProduct) {
    const shopifyProduct = entry.fields.shopifyProduct as ShopifyProduct;
    for (const variant of shopifyProduct?.variants ?? []) {
      if (variant.title.toLowerCase().includes('mosaic')) {
        variant.image.url = '/assets/images/play-kitchen/mosaic.png';
      } else if (variant.title.toLowerCase().includes('sunshine')) {
        variant.image.url = '/assets/images/play-kitchen/sunshine.png';
      } else if (variant.title.toLowerCase().includes('fruit')) {
        variant.image.url = '/assets/images/play-kitchen/fruit.png';
      } else if (variant.title.toLowerCase().includes('tiles')) {
        variant.image.url = '/assets/images/play-kitchen/tiles.png';
      } else if (variant.title.toLowerCase().includes('rainbow')) {
        variant.image.url = '/assets/images/play-kitchen/rainbow.png';
      } else if (variant.title.toLowerCase().includes('swirls')) {
        variant.image.url = '/assets/images/play-kitchen/swirls.png';
      }
    }
  }
}

async function checkNextLevel(entry: Entry<any>) {
  if (entry.fields) {
    for (const nestedEntry of Object.values(entry.fields as Entry<any>)) {
      await customizeVariantImage(nestedEntry);
    }
  }
  if (Array.isArray(entry)) {
    for (const nestedEntry of entry) {
      await customizeVariantImage(nestedEntry);
    }
  }
}

async function customizeVariantImage(entry: Entry<any> | undefined) {
  if (!entry) return;

  await updateVariantImage(entry);
  await checkNextLevel(entry);
}

export default async function customizeVariantImages<T extends object>(
  entries: EntryCollection<T>,
) {
  const fetchPromises = entries.items.map((entry) =>
    customizeVariantImage(entry),
  );
  await Promise.all(fetchPromises);
  return entries;
}
